<template>
  <QualityControl :profile="profile" :user="user" />
</template>

<script>
/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */

import { db } from '@/main.js'
import QualityControl from "@/views/admin/QualityControl.vue"

export default {
  metaInfo: {title: 'Video'},
  props: ['profile', 'user'],
  components: {QualityControl},
}
</script>

<style>

</style>
